import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuctionCreateTab from './AuctionCreateTab';
import CreateButton from '../buttons/CreateButton';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import { auctionPropertiesType } from '../../types';

CreateAuctionRow.propTypes = {
    auctionProps: auctionPropertiesType.isRequired,
};

function CreateAuctionRow(props) {
    const {
        auctionProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-auction-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('auctions.create-auction')}
            </CreateButton>
            {isCreateVisible
            && <AuctionCreateTab hideHandler={() => setCreateVisible(false)} auctionProps={auctionProps} />}
        </div>
    );
}

export default withPrivileges([Privileges.AUCTION_EDIT])(CreateAuctionRow);
